import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'Abbreviate',
})
export class AbbreviatePipe implements PipeTransform {
    transform(num: number): any {
        let SI_POSTFIXES = ["", "k", "M", "B", "T", "P", "E"];

        let tier = Math.log10(Math.abs(num)) / 3 | 0;


        if (tier == 0) return num;

        let postfix = SI_POSTFIXES[tier];
        let scale = Math.pow(10, tier * 3);

        let scaled = num / scale;

        let formatted = scaled.toFixed(1) + '';

        if (/\.0$/.test(formatted))
            formatted = formatted.substr(0, formatted.length - 2);

        return formatted + ' ' + postfix;
        return num;
    }
} 
